import React, { useState } from "react";
import { styled } from "@mui/system";
import emailjs from "@emailjs/browser";
import { Title, Subtitle, CTASection, CTAText, EmailFormWrapper, EmailInput, JoinButton, SectionContainer, Description } from "../assets/styles/ContentStyles"
import EmailInputComponent from "./EmailInputComponent";

const SecurityAdvocate = () => {

  return (
    <SectionContainer>
      <Title>
        You Can't Protect What You Can't See
      </Title>

      <Description>
        The average home now has 15+ connected devices. Your router, doorbell camera,
        smart TV, fitness tracker, and even your refrigerator could be giving hackers a way into
        your network.
      </Description>

      <Description>
        Most people have no idea their devices are vulnerable until it's too late. Security
        updates are released constantly, but who has time to track every device, read
        technical bulletins, and manually install patches?
      </Description>

      <CTAText>
        Let us be your device security advocate with your device's manufacturer.
      </CTAText>

      <Description style={{ textAlign: "center" }}>
        We'll monitor your device's vulnerabilities, alert you about new patches, and
        provide you with security advice to keep you network and data safe.
      </Description>

      <EmailInputComponent waitlistType="Security Advocate - Device Monitoring & Alerts" />
    </SectionContainer>
  );
};

export default SecurityAdvocate;
